import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { TextRecommendationModalV2 } from '@/lazy-load-components';
import BasicButton from '@/ui-components/BasicButton.vue';
import InputText from '@/features/ui/components/InputText.vue';

import { AccountModes } from '@/enums/login';
import { disableScroll, enableScroll } from '@/helpers/scroll-helper';
import { preventNonSignedInAction } from '@/helpers/prevent-non-signed-in-action-helper';

import { computed, ref } from 'vue';
import { useWtwTracking } from '../tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendationEmpty',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail };



const headline = ref('');

const displayTextRecommendationModal = ref<boolean>(false);

const backgroundImageUrl = computed(() => JW_CONFIG.IMAGESCALER_URL + props.title.content.fullPosterUrl);

const { trackWtw } = useWtwTracking({ title: () => props.title });

function toggleTextRecommendationModal(value: boolean) {
	if (preventNonSignedInAction(AccountModes.REGISTRATION_OPTIONS)) return;

	displayTextRecommendationModal.value = value;
	displayTextRecommendationModal.value ? disableScroll() : enableScroll();

	if (displayTextRecommendationModal.value) trackWtw('emptyNextClick');
}

return { __sfc: true,props, headline, displayTextRecommendationModal, backgroundImageUrl, trackWtw, toggleTextRecommendationModal, TextRecommendationModalV2, BasicButton, InputText }
}

})